/**
 * User Management - Deactivate Users Interfaces
 */

export interface HierarchyUser {
  id: number;
  hierarchy_id: string;
  mobile: string;
  username: string;
  userrole_name: string;
  status: "Active" | "Inactive";
}

export interface HierarchyUserSearchParams {
  hierarchy_id: string;
}

export interface HierarchyUserApiResponse {
  data: HierarchyUser[];
  message?: string;
}

export interface ToggleStatusPayload {
  hierarchy_id: string;
  id: number;
}

export interface ExcelHeaders {
  [key: string]: string;
}
